import DefaultMainPage from "../../pages/DefaultMainPage";
import LoginLog from "./LoginLog";
import PaymentLog from "./PaymentLog";
import MailLog from "./EmailLog";
import GoodsLog from "./GoodsLog";
import AdminLog from "./AdminLog";
import OperationLog from "./OperationLog";
import ErrorLog from "./ErrorLog";
import SpecialBlockLog from "./SpecialBlockLog";
import BanLog from "./BanLog";
import AccountActivityLog from "./AccountActivityLog";

const logMenuItems = [
    {path: "/logs", component: <LoginLog/>, label: '로그인'},
    {path: "/logs/payment", component: <PaymentLog/>, label: '결제'},
    {path: "/logs/mail", component: <MailLog/>, label: '우편'},
    {path: "/logs/item", component: <GoodsLog/>, label: '재화'},
    {path: "/logs/admin", component: <AdminLog/>, label: '관리자'},
    {path: "/logs/gachaLog", component: <OperationLog type={'RQGachaLog'}/>, label: '가차'},
    {path: "/logs/shopLog", component: <OperationLog type={'RQShopLog'}/>, label: '아이템 구입'},
    {
        path: "/logs/packageLog",
        component: <OperationLog type={'RQPassPackageLog'}/>,
       
        label: '패스/체인딜'
    },
    {path: "/logs/changeBadge", component: <OperationLog type={'RQChangeBadgeLog'}/>, label: '배지 교환'},
    {path: "/logs/rewardBadge", component: <OperationLog type={'RQBadgeRewardLog'}/>, label: '배지 보상'},
    {path: "/logs/errorLog", component: <ErrorLog />, label: '에러 로그'},
    {path: "/logs/specialBlock", component: <SpecialBlockLog />, label: '특수 블록 로그'},
    {path: "/logs/accountActivityLog", component: <AccountActivityLog />, label: '유저 활동 기록 로그'},
    {path: "/logs/mergeEventRoundClearLog", component: <OperationLog type={'RQMergeEventRoundClearLog'}/>, label: '라운드 클리어 로그'},
];

export const logsRoutes = {
    path: "/logs",
    component: <DefaultMainPage buttons={logMenuItems}/>,
    children: logMenuItems
}